import { useCallback } from "react";
import { useSelector } from "react-redux";

import {
  getTempLayerError,
  getTempLayerInfo as getTempLayerInfoSelector,
  getTempLayerSourceName,
} from "../../ducks/tempLayer/selectors";
import {
  setTempLayerSourceName as setTempLayerSourceNameAction,
  setTempLayerInfo as setTempLayerInfoAction,
  setTempLayerError as setTempLayerErrorAction,
} from "../../ducks/tempLayer/tempLayer";
import { useAction } from "../useAction";

export const useTempLayer = () => {
  const tempLayerSourceName = useSelector(getTempLayerSourceName);
  const tempLayerInfo = useSelector(getTempLayerInfoSelector);
  const tempLayerError = useSelector(getTempLayerError);
  const setTempLayerSourceName = useAction(setTempLayerSourceNameAction);
  const setTempLayerInfo = useAction(setTempLayerInfoAction);
  const setTempLayerError = useAction(setTempLayerErrorAction);

  const getTempLayerInfo = useCallback(
    (layerName: string) => (tempLayerSourceName === layerName && tempLayerInfo ? tempLayerInfo : null),
    [tempLayerInfo, tempLayerSourceName],
  );

  return {
    tempLayerSourceName,
    getTempLayerInfo,
    setTempLayerSourceName,
    setTempLayerInfo,
    tempLayerError,
    setTempLayerError,
  };
};
